import React from 'react';
import { Heart, ArrowRight } from 'lucide-react';
import { AppStoreBadges } from './AppStoreBadges';
import { useSmoothScroll } from '../hooks/useSmoothScroll';

export function Hero() {
  const { scrollTo } = useSmoothScroll();

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    scrollTo('waitlist');
  };

  return (
    <div className="relative pt-24 pb-16 px-6 overflow-hidden">
      {/* Gradient Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/80 to-white dark:from-gray-900 dark:to-gray-800 -z-10" />
      
      {/* Animated Circles */}
      <div className="absolute inset-0 overflow-hidden -z-10">
        <div className="absolute -top-1/2 -left-1/2 w-full h-full bg-primary-200/20 dark:bg-primary-500/10 rounded-full blur-3xl animate-float" />
        <div className="absolute -bottom-1/2 -right-1/2 w-full h-full bg-primary-100/20 dark:bg-primary-500/5 rounded-full blur-3xl animate-float-delayed" />
      </div>

      <div className="max-w-7xl mx-auto text-center">
        <div className="inline-flex items-center gap-2 bg-white/80 dark:bg-gray-800/80 backdrop-blur-sm text-primary-600 dark:text-primary-400 px-4 py-2 rounded-full mb-8 animate-fade-in shadow-sm hover:shadow-md transition-all cursor-default">
          <Heart className="w-4 h-4 animate-pulse" />
          <span>Coming Soon</span>
        </div>

        <h1 className="text-4xl md:text-6xl font-bold text-gray-900 dark:text-white mb-6 leading-tight animate-fade-in-up">
          A Safe & Supportive Community for
          <span className="bg-gradient-to-r from-primary-500 to-primary-600 bg-clip-text text-transparent animate-gradient block mt-2">
            Individuals with Herpes and Other STDs
          </span>
        </h1>

        <p className="text-xl text-gray-600 dark:text-gray-300 mb-8 max-w-2xl mx-auto animate-fade-in-up delay-100">
          Join a judgment-free space where meaningful connections flourish. 
          Experience dating with privacy, understanding, and respect.
        </p>

        <a 
          href="#waitlist"
          onClick={handleClick}
          className="group inline-flex items-center gap-2 bg-primary-500 text-white px-8 py-4 rounded-full text-lg font-medium hover:bg-primary-600 transition-all transform hover:scale-105 hover:shadow-lg animate-fade-in-up delay-200"
        >
          Join the Waitlist
          <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
        </a>

        <AppStoreBadges />
      </div>
    </div>
  );
}